/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "us-east-2",
  aws_cognito_identity_pool_id:
    "us-east-2:e114ad22-f773-491b-b915-67c94bdd116b",
  aws_cognito_region: "us-east-2",
  aws_user_pools_id: "us-east-2_rMJf3SE8f",
  aws_user_pools_web_client_id: "7re4uphkrch3kioall8nsf01e1",
  oauth: {},
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_appsync_graphqlEndpoint:
    "https://yo6cosrphvgu7kfukau5d5hgdu.appsync-api.us-east-2.amazonaws.com/graphql",
  aws_appsync_region: "us-east-2",
  aws_appsync_authenticationType: "API_KEY",
  aws_appsync_apiKey: "da2-cymo5j2suzebxeksnfonpcghqi",
  aws_user_files_s3_bucket: "meritcare-prod92018-production",
  aws_user_files_s3_bucket_region: "us-east-2",
};

export default awsmobile;
